import React from 'react';
interface TrustLineProps {
  items: string[];
}
export function TrustLine({
  items
}: TrustLineProps) {
  return <p className="mt-2 text-center font-display text-xs font-semibold uppercase tracking-wide text-ink sm:text-sm" data-id="element-191" data-mp="3oxdpw95eg11l">
      {items.map((item, i) => <React.Fragment key={item} data-id="element-192" data-mp="3kyof8obqwxln" data-mpi={i}>
          {i > 0 && <span className="mx-1.5 text-gold-dark" data-id="element-193" data-mp="3fysb8p31t663">|</span>}
          {item}
        </React.Fragment>)}
    </p>;
}